import {
  Grid,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles';
import {
  isNotBlank,
  statesAbbreviation,
  statesNames,
} from '@roc/feature-utils';
import {
  GoogleMap,
  AutocompleteAddressField,
  createTextField,
  createSelectField
} from '@roc/ui';
import { observer } from 'mobx-react';
import { isNil } from '@roc/feature-utils';


const useAddressStyles = makeStyles((theme: Theme) => ({
  autocompleteContainer: {
    marginBottom: theme.spacing(2),
  },
  mapStyles: {
    position: 'relative',
    width: '100%',
    height: '150px',
  },
}));

const STREET_NUMBER_REGEX = /^(\d+)\s(.*)$/;

const stateOptions = statesAbbreviation.map((abbreviation, i) => ({
  value: abbreviation,
  label: statesNames[i],
}));

export const ReferralBorrowerAddressInformation = observer(
  ({
    testId = 'address',
    store,
    disabled = false,
    standaloneLabel = true,
    showMap = true,
    autoFocus = false,
    addMarkForRequiredFields = true,
  }) => {
    const classes = useAddressStyles();

    const formFields = store?.form?.fields;

    const handleAddressChange = event => {
      const { value, fullInfo } = event?.target || {};
      const { address_components, geometry } = fullInfo || {};
      if (!isNil(address_components) && !isNil(geometry)) {
        store.saveAddressField(value, address_components, geometry);
      } else {
        const address = event.target.value;
        store.onFieldChange('address', address);
        if (STREET_NUMBER_REGEX.test(address)) {
          const [, streetNumber, streetName] = address.match(
            STREET_NUMBER_REGEX
          );
          store.onFieldChange('streetName', streetName);
          store.onFieldChange('streetNumber', streetNumber);
        } else {
          store.onFieldChange('streetName', address);
          store.onFieldChange('streetNumber', '');
        }
      }
    };

    const stateOptionsFiltered = [...stateOptions];
    stateOptionsFiltered.shift();

    const showGoogleMap =
      showMap &&
      Boolean(formFields?.latitude?.value && formFields?.longitude?.value);

    return (
      <Grid container spacing={2}>
        <Grid item xs={6} >
          <AutocompleteAddressField
            label="Address Line 1"
            disabled={disabled}
            required={true}
            name="address"
            value={formFields?.address?.value}
            error={
              isNotBlank(formFields?.address?.error) ||
              isNotBlank(formFields.__isAddressInCorrectFormat__.error)
            }
            errorText={
              formFields?.address?.error ||
              formFields?.__isAddressInCorrectFormat__?.error
            }
            onChange={handleAddressChange}
            fullWidth
            testId={`address-${testId}`}
            standaloneLabel={standaloneLabel}
            autoFocus={autoFocus}
          />
        </Grid>
        <Grid item xs={6} >
          {createTextField({
            label: 'Address Line 2',
            fieldName: 'aptNumber',
            testId: `aptNumber-${testId}`,
            store: store,
            disabled,
            standaloneLabel,
          })}
        </Grid>
        <Grid item xs={4} >
          {createTextField({
            label: 'City',
            fieldName: 'city',
            testId: `city-${testId}`,
            store: store,
            disabled,
            standaloneLabel,
          })}
        </Grid>
        <Grid item xs={4} >
          {createSelectField({
            store: store,
            testId: `state-${testId}`,
            fieldName: 'state',
            label: 'State',
            options: stateOptionsFiltered,
            disabled,
            standaloneLabel,
          })}
        </Grid>
        <Grid item xs={4} >
          {createTextField({
            label: 'Zip Code',
            fieldName: 'zipCode',
            testId: `zipCode-${testId}`,
            store: store,
            disabled,
            standaloneLabel,
          })}
        </Grid>
        {showGoogleMap && (
          <Grid item xs={12}>
            <GoogleMap
              mapStyles={classes.mapStyles}
              latitude={formFields?.latitude?.value}
              longitude={formFields?.longitude?.value}
            />
          </Grid>
        )}
      </Grid>
    );
  }
);